import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../layoutPages/components/PageTitle';
import { HaveImage, Paragraph } from '../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../layoutPages/defaultSetting';
import { DottedList } from '../../layoutPages/containers/DottedList';
import { MainCard } from '../../layoutPages/components/MainCard';
import ChangeHistoryTwoToneIcon from '@mui/icons-material/ChangeHistoryTwoTone';
import StarsIcon from '@mui/icons-material/Stars';
import WebIcon from '@mui/icons-material/Web';
import { mathMenuData } from '../../data/SubjectMenu/mathMenuData';
import { MainCards } from '../../layoutPages/containers/MainCards';
import { MaterialList, MaterialWithLink } from '../../layoutPages/components/MaterialList';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export function other_report() {

    const data: Array<MaterialWithLink> = [
        
        { name: "「校園‧好精神一筆過津貼」運用計劃(2024-2025)", src: "http://www.pkps.edu.hk/pdf/2024-2025/report/11/2425a.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "支援開設小學科學科一筆過津貼計劃(2024-2025)",  src: "http://www.pkps.edu.hk/pdf/2024-2025/report/11/2425b.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "支援學校推動校園體育氛圍津貼計劃(2024-2025)",  src: "http://www.pkps.edu.hk/pdf/2024-2025/report/11/2425c.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "家長教育津貼運用計劃(2024-2025)", src: "http://www.pkps.edu.hk/pdf/2024-2025/report/11/2425d.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "家長教育津貼運用報告(2023-2024)", src: "http://www.pkps.edu.hk/pdf/2024-2025/report/11/2324a.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },
        { name: "推廣中華文化體驗活動一筆過津貼計劃(2024-2025)", src: "http://www.pkps.edu.hk/pdf/2024-2025/report/11/2425e.pdf", icon: <PictureAsPdfIcon sx={{ color: "red" }} /> },

    ]

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <PageTitle title='計劃/報告 | 各類一次性津貼計劃' size='h3' />
    
            <Grid item xs={11} sm={10} sx={{ p: 2 }}>
               
                <Paragraph title="" sx={{ mt: 2 }}
                    instantAppear
                    data={[
                        <MaterialList data={data} />]}
                />

            </Grid>

        </Grid>
    )
}